import { render, staticRenderFns } from "./SaleInvoice.vue?vue&type=template&id=84713cd2&"
import script from "./SaleInvoice.vue?vue&type=script&lang=js&"
export * from "./SaleInvoice.vue?vue&type=script&lang=js&"
import style0 from "./SaleInvoice.vue?vue&type=style&index=0&id=84713cd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports